function createTimeoutHelpers(getClient) {
  return {
    set timeout(time) {
      getClient().timeout(time);
    },
  };
}

export default createTimeoutHelpers;
